export enum REDUX_ACTION_FROM {
  UNDO = "undo",
  REDO = "redo",
  WS = "ws",
}
